import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { City } from 'src/app/interfaces/city';
import { Kecamatan, Provinsi } from 'src/app/interfaces/location';
import { LocationService } from 'src/app/services/location.service';

@Component({
  selector: 'app-modal-select-kecamatan',
  templateUrl: './modal-select-kecamatan.component.html',
  styleUrls: ['./modal-select-kecamatan.component.scss'],
})
export class ModalSelectKecamatanComponent implements OnInit {
  @Input() id_city: string;
  @Input() selectedKecamatan: Kecamatan;
  @ViewChild('infiniteScroll') infiniteScroll: IonInfiniteScroll;

  list_kecamatan: Kecamatan[] = [];
  isLoading = true;
  skeletonLoadings = new Array(15);

  private term: string;

  constructor(private modalController: ModalController, private locationService: LocationService) {}

  ngOnInit() {
    this.loadData();
  }

  async onSubmit() {
    await this.modalController.dismiss(this.selectedKecamatan, 'confirm');
  }

  async onClose() {
    await this.modalController.dismiss();
  }

  onSelect(kecamatan: Kecamatan) {
    this.selectedKecamatan = kecamatan;
  }

  onSearch(event: Event) {
    this.term = (event.target as HTMLInputElement).value;
    this.list_kecamatan = [];
    this.loadData();
  }

  onClear() {
    this.term = null;
    this.list_kecamatan = [];
    this.loadData();
  }

  onInfiniteScroll() {
    if (!this.isLoading) {
      this.loadData();
    }
  }

  private loadData() {
    this.isLoading = true;

    this.locationService.getKecamatan(this.id_city).subscribe({
      next: res => {
        if (this.term) {
          this.list_kecamatan = res.value.filter(c => c.name.toLowerCase().includes(this.term.toLowerCase()));
        } else {
          this.list_kecamatan = res.value;
        }
      },
    });
  }
}
